import { Input } from '@/components/ui/input'
import { TextboxProps } from '@/formBuilder/node.types'

interface InputCmpProps {
  node: TextboxProps
  handleChange: (key: string, value: string) => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  className?: string
  button?: React.ReactNode
  userAvatar?: boolean
  addButton?: boolean
}

export function InputCmp({
  node,
  handleChange,
  onKeyDown,
  className,
  button,
  userAvatar,
  addButton,
}: InputCmpProps) {
  return (
    <Input
      node={node}
      className={className}
      handleChange={handleChange}
      onKeyDown={onKeyDown}
      button={button}
      userAvatar={userAvatar}
      addButton={addButton}
      data-testid={`${node.id}-input`}
    />
  )
}
